import {
    AcsServerError,
    ApiNorthboundError,
    DatabaseError,
    DataCollectorError,
    DcbError,
    DeviceAccessError,
    DwdmCircuitsError,
    ErrorCodeMap,
    GenericError,
    LinkError,
    MuxError,
    NesError,
    NmsSecurityError,
    NmsTemplateError,
    NotificationServiceError,
    SchedulerError,
} from "./error-response-handler.model";

export const NES_ERROR_NAME: ErrorCodeMap<NesError> = {
    [NesError.UNKNOWN_ERROR]                   : "UNKNOWN_ERROR",
    [NesError.DEVICE_ACCESS_ERROR]             : "DEVICE_ACCESS_ERROR",
    [NesError.DEVICE_COMMUNICATION_ERROR]      : "DEVICE_COMMUNICATION_ERROR",
    [NesError.CONFIGURATION_CHANGED_ERROR]     : "CONFIGURATION_CHANGED_ERROR",
    [NesError.NETWORK_ELEMENT_NOT_IDENTIFIED]  : "NETWORK_ELEMENT_NOT_IDENTIFIED",
    [NesError.DEVICE_LOCKED]                   : "DEVICE_LOCKED",
    [NesError.DEVICE_AUTHENTICATION_ERROR]     : "DEVICE_AUTHENTICATION_ERROR",
    [NesError.UNEXPECTED_DEVICE_BEHAVIOR]      : "UNEXPECTED_DEVICE_BEHAVIOR",
    [NesError.MONGO_ACCESS_ERROR]              : "MONGO_ACCESS_ERROR",
    [NesError.INVENTORY_UNAVAILABLE_ERROR]     : "INVENTORY_UNAVAILABLE_ERROR",
    [NesError.DISCOVERY_ERROR]                 : "DISCOVERY_ERROR",
    [NesError.DEVICE_CONFIGURATION_ERROR]      : "DEVICE_CONFIGURATION_ERROR",
    [NesError.NETWORK_ELEMENT_NOT_FOUND_IN_DB] : "NETWORK_ELEMENT_NOT_FOUND_IN_DB",
    [NesError.TIMEOUT_ERROR]                   : "TIMEOUT_ERROR",
    [NesError.PARSER_ERROR]                    : "PARSER_ERROR",
    [NesError.UNKNOW_DEVICE_ERROR]             : "UNKNOW_DEVICE_ERROR",
    [NesError.FIRMWARE_VERSION_ERROR]          : "FIRMWARE_VERSION_ERROR",
    [NesError.ACCESS_DENIED_ERROR]             : "ACCESS_DENIED_ERROR"
};

export const DEVICE_ACCESS_ERROR_NAME: ErrorCodeMap<DeviceAccessError> = {
    [DeviceAccessError.GENERIC_DEVICE_ERROR] : "GENERIC_DEVICE_ERROR",
    [DeviceAccessError.UNREACHABLE_DEVICE]   : "UNREACHABLE_DEVICE"
}

export const GENERIC_ERROR_NAME: ErrorCodeMap<GenericError> = {
    [GenericError.UNEXPECTED_ERROR] : "UNEXPECTED_ERROR"
}

export const DATABASE_ERROR_NAME: ErrorCodeMap<DatabaseError> = {
    [DatabaseError.DATABASE_ERROR]       : "DATABASE_ERROR",
    [DatabaseError.DEVICE_ALREADY_ADDED] : "DEVICE_ALREADY_ADDED"
}

export const DATA_COLLECTOR_ERROR_NAME: ErrorCodeMap<DataCollectorError> = {
    [DataCollectorError.TOO_MANY_RESULTS_FOUND] : "TOO_MANY_RESULTS_FOUND"
}

export const ACS_SERVER_ERROR_NAME: ErrorCodeMap<AcsServerError> = {
    [AcsServerError.ACS_CONNECTION_REQUEST_ERROR]                : "ACS_CONNECTION_REQUEST_ERROR",
    [AcsServerError.ACS_BAD_CONDITIONAL_COMMAND_ERROR]           : "ACS_BAD_CONDITIONAL_COMMAND_ERROR",
    [AcsServerError.ACS_COULD_NOT_ACCESS_SERVER_ERROR]           : "ACS_COULD_NOT_ACCESS_SERVER_ERROR",
    [AcsServerError.ACS_CONNECTION_REQUEST_AUTHENTICATION_ERROR] : "ACS_CONNECTION_REQUEST_AUTHENTICATION_ERROR",
    [AcsServerError.ACS_CPE_MESSAGE_TIMEOUT]                     : "ACS_CPE_MESSAGE_TIMEOUT",
    [AcsServerError.ACS_UNEXPECTED_ERROR]                        : "ACS_UNEXPECTED_ERROR",
    [AcsServerError.UNEXPECTED_CPE_MESSAGE]                      : "UNEXPECTED_CPE_MESSAGE",
    [AcsServerError.ACS_DUPLICATED_USER]                         : "ACS_DUPLICATED_USER"
}

export const NMS_SECURITY_ERROR_NAME: ErrorCodeMap<NmsSecurityError> = {
    [NmsSecurityError.INVALID_CAPTCHA] : "INVALID_CAPTCHA"
}

export const NOTIFICATION_SERVICE_ERROR_NAME: ErrorCodeMap<NotificationServiceError> = {
    [NotificationServiceError.INVALID_NOTIFICATION_PREFERENCES_ERROR] : "INVALID_NOTIFICATION_PREFERENCES_ERROR"
}

export const SCHEDULER_ERROR_NAME: ErrorCodeMap<SchedulerError> = {
    [SchedulerError.JOB_NOT_FOUND_ERROR]                              : "JOB_NOT_FOUND_ERROR",
    [SchedulerError.SCHEDULER_UNEXPECTED_ERROR]                       : "SCHEDULER_UNEXPECTED_ERROR",
    [SchedulerError.INVALID_CRON_EXPRESSION_ERROR]                    : "INVALID_CRON_EXPRESSION_ERROR",
    [SchedulerError.SCHEDULER_REMOVAL_ERROR]                          : "SCHEDULER_REMOVAL_ERROR",
    [SchedulerError.JOB_EXECUTION_ERROR]                              : "JOB_EXECUTION_ERROR",
    [SchedulerError.USER_WITHOUT_SCHEDULER_PERMISSION_ERROR]          : "USER_WITHOUT_SCHEDULER_PERMISSION_ERROR",
    [SchedulerError.USER_WITHOUT_JOB_TYPE_SCHEDULER_PERMISSION_ERROR] : "USER_WITHOUT_JOB_TYPE_SCHEDULER_PERMISSION_ERROR",
    [SchedulerError.USER_WITHOUT_CREATE_SCHEDULER_PERMISSION_ERROR]   : "USER_WITHOUT_CREATE_SCHEDULER_PERMISSION_ERROR",
    [SchedulerError.INVALID_BACKUP_DEVICE_MODEL_SCHEDULER_ERROR]      : "INVALID_BACKUP_DEVICE_MODEL_SCHEDULER_ERROR"
}

export const NMS_TEMPLATE_ERROR_NAME: ErrorCodeMap<NmsTemplateError> = {
    [NmsTemplateError.DEVICE_WITHOUT_MANAGE_PERMISSION_ERROR]            : "DEVICE_WITHOUT_MANAGE_PERMISSION_ERROR",
    [NmsTemplateError.AUTO_SELECTION_VARIABLE_VALUE_NOT_AVAILABLE_ERROR] : "AUTO_SELECTION_VARIABLE_VALUE_NOT_AVAILABLE_ERROR",
    [NmsTemplateError.AUDIT_SETTINGS_VALIDATION_ERROR]                   : "AUDIT_SETTINGS_VALIDATION_ERROR"
}

export const DCB_ERROR_NAME: ErrorCodeMap<DcbError> = {
    [DcbError.UNKNOWN_DCB_ERROR]                 : "UNKNOWN_DCB_ERROR",
    [DcbError.UNSUPPORTED_DCB_FILES_ERROR]       : "UNSUPPORTED_DCB_FILES_ERROR",
    [DcbError.DEVICE_COMMUNICATION_DCB_ERROR]    : "DEVICE_COMMUNICATION_DCB_ERROR",
    [DcbError.CONFIG_CHANGED_DCB_ERROR]          : "CONFIG_CHANGED_DCB_ERROR",
    [DcbError.DEVICE_NOT_IDENTIFIED_DCB_ERROR]   : "DEVICE_NOT_IDENTIFIED_DCB_ERROR",
    [DcbError.DEVICE_LOCKED_DCB_ERROR]           : "DEVICE_LOCKED_DCB_ERROR",
    [DcbError.DEVICE_AUTHENTICATION_DCB_ERROR]   : "DEVICE_AUTHENTICATION_DCB_ERROR",
    [DcbError.DATABASE_ACCESS_DCB_ERROR]         : "DATABASE_ACCESS_DCB_ERROR",
    [DcbError.SERVICE_UNAVAILABLE_DCB_ERROR]     : "SERVICE_UNAVAILABLE_DCB_ERROR",
    [DcbError.DEVICE_CONFIGURATION_DCB_ERROR]    : "DEVICE_CONFIGURATION_DCB_ERROR",
    [DcbError.FIRST_POLLING_FAILED_DCB_ERROR]    : "FIRST_POLLING_FAILED_DCB_ERROR",
    [DcbError.FIRMWARE_VERSION_DCB_ERROR]        : "FIRMWARE_VERSION_DCB_ERROR",
    [DcbError.ACCESS_DENIED_DCB_ERROR]           : "ACCESS_DENIED_DCB_ERROR",
    [DcbError.DEVICE_CONFIG_PARSER_DCB_ERROR]    : "DEVICE_CONFIG_PARSER_DCB_ERROR",
    [DcbError.CORRUPTED_FILE_DCB_ERROR]          : "CORRUPTED_FILE_DCB_ERROR",
    [DcbError.PROTECTED_DCB_ERROR]               : "PROTECTED_DCB_ERROR",
    [DcbError.DCB_NOT_FOUND]                     : "DCB_NOT_FOUND",
    [DcbError.EXPORT_CONFIG_PARSER_DCB_ERROR]    : "EXPORT_CONFIG_PARSER_DCB_ERROR",
    [DcbError.POLLER_COMMUNICATION_DCB_ERROR]    : "POLLER_COMMUNICATION_DCB_ERROR",
    [DcbError.DCB_RETENTION_CONFIGURATION_ERROR] : "DCB_RETENTION_CONFIGURATION_ERROR",
    [DcbError.DCB_MODEL_OPERATION_ERROR]         : "DCB_MODEL_OPERATION_ERROR",
};

export const API_NORTHBOUND_ERROR_NAME: ErrorCodeMap<ApiNorthboundError> = {
    [ApiNorthboundError.BAD_REQUEST_ERROR]     : "BAD_REQUEST_ERROR",
    [ApiNorthboundError.DATA_NOT_FOUND_ERROR]  : "DATA_NOT_FOUND_ERROR",
    [ApiNorthboundError.DUPLICATED_DATA_ERROR] : "DUPLICATED_DATA_ERROR",
    [ApiNorthboundError.VALIDATION_ERROR]      : "VALIDATION_ERROR",
    [ApiNorthboundError.FORBIDDEN_ERROR]       : "FORBIDDEN_ERROR",
    [ApiNorthboundError.INTERNAL_SERVER_ERROR] : "INTERNAL_SERVER_ERROR",
    [ApiNorthboundError.VARIABLE_VALUES_ERROR] : "VARIABLE_VALUES_ERROR"
};

export const LINKS_ERROR_NAME: ErrorCodeMap<LinkError> = {
    [LinkError.DEVICE_NOT_FOUND_LINK_ERROR]                  : "DEVICE_NOT_FOUND_LINK_ERROR",
    [LinkError.EMPTY_LINK_NAME_ERROR]                        : "EMPTY_LINK_NAME_ERROR",
    [LinkError.DUPLICATED_NAME_LINK_ERROR]                   : "DUPLICATED_NAME_LINK_ERROR",
    [LinkError.PART_OF_RESOURCE_LINK_ERROR]                  : "PART_OF_RESOURCE_LINK_ERROR",
    [LinkError.PORTS_VALIDATION_LINK_ERROR]                  : "PORTS_VALIDATION_LINK_ERROR",
    [LinkError.SLOTS_VALIDATION_LINK_ERROR]                  : "SLOTS_VALIDATION_LINK_ERROR",
    [LinkError.LINK_TYPE_ERROR]                              : "LINK_TYPE_ERROR",
    [LinkError.PORT_ALREADY_LINKABLE_ERROR]                  : "PORT_ALREADY_LINKABLE_ERROR",
    [LinkError.PORT_NOT_COMPATIBLE_ERROR]                    : "PORT_NOT_COMPATIBLE_ERROR",
    [LinkError.AT_LEAST_ONE_MEMBER_PORT_ERROR]               : "AT_LEAST_ONE_MEMBER_PORT_ERROR",
    [LinkError.UNSUPPORTED_LINK_BETWEEN_DEVICE_MODELS_ERROR] : "UNSUPPORTED_LINK_BETWEEN_DEVICE_MODELS_ERROR",
    [LinkError.DIFFERENT_NUMBER_OF_PORTS_ERROR]              : "DIFFERENT_NUMBER_OF_PORTS_ERROR",
    [LinkError.PORT_PART_OF_PORTCHANNEL_ERROR]               : "PORT_PART_OF_PORTCHANNEL_ERROR",
    [LinkError.MEMBER_PORT_ALREADY_LINKED_ERROR]             : "MEMBER_PORT_ALREADY_LINKED_ERROR",
    [LinkError.PRIVATE_VLAN_PORT_ERROR]                      : "PRIVATE_VLAN_PORT_ERROR",
    [LinkError.DUPLICATED_DEVICES_ERROR]                     : "DUPLICATED_DEVICES_ERROR",
    [LinkError.LINK_WITHOUT_CHANGES_ERROR]                   : "LINK_WITHOUT_CHANGES_ERROR",
    [LinkError.LINK_NAME_MAX_SIZE_ERROR]                     : "LINK_NAME_MAX_SIZE_ERROR",
    [LinkError.COST_RANGE_VALIDATOR_ERROR]                   : "COST_RANGE_VALIDATOR_ERROR",
    [LinkError.NMS_MAP_NOT_REFLECT_LINK_CHANGE_ERROR]        : "NMS_MAP_NOT_REFLECT_LINK_CHANGE_ERROR",
    [LinkError.POLLER_COMMUNICATION_LINK_ERROR]              : "POLLER_COMMUNICATION_LINK_ERROR",
    [LinkError.DISTANCE_VALIDATOR_ERROR]                     : "DISTANCE_VALIDATOR_ERROR",
    [LinkError.ATTENUATION_VALIDATOR_ERROR]                  : "ATTENUATION_VALIDATOR_ERROR",
    [LinkError.UNSELECT_MUX_DEMUX_ERROR]                     : "UNSELECT_MUX_DEMUX_ERROR",
    [LinkError.SAME_TRANSMISSION_ERROR]                      : "SAME_TRANSMISSION_ERROR",
    [LinkError.SOME_TRANSMISSION_NONE_ERROR]                 : "SOME_TRANSMISSION_NONE_ERROR",
    [LinkError.MUX_NOT_COMPATIBLE_ERROR]                     : "MUX_NOT_COMPATIBLE_ERROR",
    [LinkError.DWDM_LINK_INVALID_DEVICES_ERROR]              : "DWDM_LINK_INVALID_DEVICES_ERROR"
};

export const MUX_ERROR_NAME: ErrorCodeMap<MuxError> = {
    [MuxError.MUX_NAME_REQUIRED_ERROR]                : "MUX_NAME_REQUIRED_ERROR",
    [MuxError.MUX_NAME_DUPLICATED_ERROR]              : "MUX_NAME_DUPLICATED_ERROR",
    [MuxError.MUX_NAME_LENGTH_ERROR]                  : "MUX_NAME_LENGTH_ERROR",
    [MuxError.MUX_SERIAL_NUMBER_FORMAT_ERROR]         : "MUX_SERIAL_NUMBER_FORMAT_ERROR",
    [MuxError.MUX_SERIAL_NUMBER_LENGTH_ERROR]         : "MUX_SERIAL_NUMBER_LENGTH_ERROR",
    [MuxError.MUX_MODEL_REQUIRED_ERROR]               : "MUX_MODEL_REQUIRED_ERROR",
    [MuxError.MUX_MODEL_INVALID_ERROR]                : "MUX_MODEL_INVALID_ERROR",
    [MuxError.MUX_ASSOCIATED_DEVICES_SIZE_ERROR]      : "MUX_ASSOCIATED_DEVICES_SIZE_ERROR",
    [MuxError.MUX_ASSOCIATED_DEVICES_MODEL_ERROR]     : "MUX_ASSOCIATED_DEVICES_MODEL_ERROR",
    [MuxError.MUX_DISASSOCIATED_DEVICES_MODEL_ERROR]  : "MUX_DISASSOCIATED_DEVICES_MODEL_ERROR",
    [MuxError.MUX_DESCRIPTION_LENGTH_ERROR]           : "MUX_DESCRIPTION_LENGTH_ERROR",
    [MuxError.USED_MUX_MODEL_MODIFIED_ERROR]          : "USED_MUX_MODEL_MODIFIED_ERROR",
    [MuxError.MUX_PART_OF_LINK_ERROR]                 : "MUX_PART_OF_LINK_ERROR",
    [MuxError.MUX_NOT_FOUND_ERROR]                    : "MUX_NOT_FOUND_ERROR",
    [MuxError.MUX_PART_OF_CIRCUIT_ERROR]              : "MUX_PART_OF_CIRCUIT_ERROR"
};

export const DWDM_CIRCUITS_ERROR_NAME: ErrorCodeMap<DwdmCircuitsError> = {
    [DwdmCircuitsError.DWDM_CIRCUIT_INVALID_DEVICES_ERROR]   : "DWDM_CIRCUIT_INVALID_DEVICES_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_SAME_ENDS_ERROR]         : "DWDM_CIRCUIT_SAME_ENDS_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_PORT_COUNT_MATCHES_ERROR]: "DWDM_CIRCUIT_PORT_COUNT_MATCHES_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_DEVICE_STATUS_ERROR]     : "DWDM_CIRCUIT_DEVICE_STATUS_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_PORT_MODEL_ERROR]        : "DWDM_CIRCUIT_PORT_MODEL_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_PORT_IN_USE_ERROR]       : "DWDM_CIRCUIT_PORT_IN_USE_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_MUX_REQUIRED_ERROR]      : "DWDM_CIRCUIT_MUX_REQUIRED_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_BOTH_END_MUX_ERROR]      : "DWDM_CIRCUIT_BOTH_END_MUX_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_MUX_ASSOCIATION_ERROR]   : "DWDM_CIRCUIT_MUX_ASSOCIATION_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_DEVICE_PERMISSION_ERROR] : "DWDM_CIRCUIT_DEVICE_PERMISSION_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_REMOVE_ACTIVATION_ERROR] : "DWDM_CIRCUIT_REMOVE_ACTIVATION_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_NOT_FOUND]               : "DWDM_CIRCUIT_NOT_FOUND",
    [DwdmCircuitsError.DWDM_CIRCUIT_REMOVED_BUT_STILL_IN_DB] : "DWDM_CIRCUIT_REMOVED_BUT_STILL_IN_DB",
    [DwdmCircuitsError.DWDM_CIRCUIT_INVALID_TX_POWER]        : "DWDM_CIRCUIT_INVALID_TX_POWER",
    [DwdmCircuitsError.DWDM_CIRCUIT_CHANNEL_MISMATCH_ERROR]  : "DWDM_CIRCUIT_CHANNEL_MISMATCH_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_CHANNEL_MULTIRATE_MATCH_ERROR]: "DWDM_CIRCUIT_CHANNEL_MULTIRATE_MATCH_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_CHANNEL_FREQUENCY_ERROR] : "DWDM_CIRCUIT_CHANNEL_FREQUENCY_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_CHANNEL_USED_BY_MUX_ERROR] : "DWDM_CIRCUIT_CHANNEL_USED_BY_MUX_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_CHANNEL_IN_USE_BY_PORT_ERROR]: "DWDM_CIRCUIT_CHANNEL_IN_USE_BY_PORT_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_INVALID_MUX_CHANNEL_RANGE]: "DWDM_CIRCUIT_INVALID_MUX_CHANNEL_RANGE",
    [DwdmCircuitsError.DWDM_CIRCUIT_UPDATED_BUT_NOT_IN_DB]: "DWDM_CIRCUIT_UPDATED_BUT_NOT_IN_DB",
    [DwdmCircuitsError.DWDM_CIRCUIT_INTERMEDIATE_WITHOUT_EDFA_PORT]: "DWDM_CIRCUIT_INTERMEDIATE_WITHOUT_EDFA_PORT",
    [DwdmCircuitsError.DWDM_CIRCUIT_INTERMEDIATE_IS_EQUALS_ONE_END]: "DWDM_CIRCUIT_INTERMEDIATE_IS_EQUALS_ONE_END",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_NOT_ACTIVE_SITUATION]: "DWDM_CIRCUIT_LINK_NOT_ACTIVE_SITUATION",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_TYPE_IS_NOT_DWDM]: "DWDM_CIRCUIT_LINK_TYPE_IS_NOT_DWDM",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_MUX_CANNOT_BE_USED]: "DWDM_CIRCUIT_LINK_MUX_CANNOT_BE_USED",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_DEVICES_NOT_IN_CIRCUIT]: "DWDM_CIRCUIT_LINK_DEVICES_NOT_IN_CIRCUIT",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_TX_RX_REQUIRED]: "DWDM_CIRCUIT_LINK_TX_RX_REQUIRED",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_INVALID_COUNT_ON_INTERMEDIATE]: "DWDM_CIRCUIT_LINK_INVALID_COUNT_ON_INTERMEDIATE",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_TX_RX_MISMATCH]: "DWDM_CIRCUIT_LINK_TX_RX_MISMATCH",
    [DwdmCircuitsError.DWDM_CIRCUIT_AMPLIFIER_MUST_BE_CONFIGURED]: "DWDM_CIRCUIT_AMPLIFIER_MUST_BE_CONFIGURED",
    [DwdmCircuitsError.DWDM_CIRCUIT_AMPLIFIER_INVALID_CONFIGURED_VALUE]: "DWDM_CIRCUIT_AMPLIFIER_INVALID_CONFIGURED_VALUE",
    [DwdmCircuitsError.DWDM_CIRCUIT_ENDS_MUST_HAVE_ONLY_ONE_OSC]: "DWDM_CIRCUIT_ENDS_MUST_HAVE_ONLY_ONE_OSC",
    [DwdmCircuitsError.DWDM_CIRCUIT_ENDS_TX_MUST_HAVE_A_TX_OSC]: "DWDM_CIRCUIT_ENDS_TX_MUST_HAVE_A_TX_OSC",
    [DwdmCircuitsError.DWDM_CIRCUIT_ENDS_RX_MUST_HAVE_A_RX_OSC]: "DWDM_CIRCUIT_ENDS_RX_MUST_HAVE_A_RX_OSC",
    [DwdmCircuitsError.DWDM_CIRCUIT_MULTIPLE_OSC_MANAGEMENT_PROFILES]: "DWDM_CIRCUIT_MULTIPLE_OSC_MANAGEMENT_PROFILES",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINK_FOUR_HUNDRED_CANNOT_BE_USED]: "DWDM_CIRCUIT_LINK_FOUR_HUNDRED_CANNOT_BE_USED",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINKS_WITH_MUX_NOT_ALLOWED]: "DWDM_CIRCUIT_LINKS_WITH_MUX_NOT_ALLOWED",
    [DwdmCircuitsError.DWDM_CIRCUIT_INTERMEDIATES_MUST_HAVE_EDFA_PORT]: "DWDM_CIRCUIT_INTERMEDIATES_MUST_HAVE_EDFA_PORT",
    [DwdmCircuitsError.DWDM_CIRCUIT_EDFA_PORT_ALREADY_IN_USE]: "DWDM_CIRCUIT_EDFA_PORT_ALREADY_IN_USE",
    [DwdmCircuitsError.DWDM_CIRCUIT_INTERMEDIATES_MUST_HAVE_MAX_TWO_OSC]: "DWDM_CIRCUIT_INTERMEDIATES_MUST_HAVE_MAX_TWO_OSC",
    [DwdmCircuitsError.DWDM_CIRCUIT_LINKS_REQUIRED]: "DWDM_CIRCUIT_LINKS_REQUIRED",
    [DwdmCircuitsError.DWDM_CIRCUIT_NAME_INVALID_LENGTH]: "DWDM_CIRCUIT_NAME_INVALID_LENGTH",
    [DwdmCircuitsError.DWDM_CIRCUIT_DUPLICATED_NAME]: "DWDM_CIRCUIT_DUPLICATED_NAME",
    [DwdmCircuitsError.DWDM_CIRCUIT_DESCRIPTION_INVALID_LENGTH]: "DWDM_CIRCUIT_DESCRIPTION_INVALID_LENGTH",
    [DwdmCircuitsError.DWDM_CIRCUIT_CREATE_UPDATE_ACTIVATION_ERROR]: "DWDM_CIRCUIT_CREATE_UPDATE_ACTIVATION_ERROR",
    [DwdmCircuitsError.DWDM_CIRCUIT_CARD_NOT_PROVISIONED]: "DWDM_CIRCUIT_CARD_NOT_PROVISIONED"
}

export const ERROR_NAME = {
    ...NES_ERROR_NAME,
    ...DEVICE_ACCESS_ERROR_NAME,
    ...DATABASE_ERROR_NAME,
    ...DATA_COLLECTOR_ERROR_NAME,
    ...ACS_SERVER_ERROR_NAME,
    ...NMS_SECURITY_ERROR_NAME,
    ...NOTIFICATION_SERVICE_ERROR_NAME,
    ...SCHEDULER_ERROR_NAME,
    ...NMS_TEMPLATE_ERROR_NAME,
    ...DCB_ERROR_NAME,
    ...API_NORTHBOUND_ERROR_NAME,
    ...LINKS_ERROR_NAME,
    ...MUX_ERROR_NAME,
    ...DWDM_CIRCUITS_ERROR_NAME,
    ...GENERIC_ERROR_NAME
}
